import installationInstructions from './installationInstructions';

const switchCategoryContent = {
  installationInstructions
}

export { switchCategoryContent };
